import React from 'react';

export const ImageGuidelines: React.FC = () => (
  <ul>
    <li>Only JPEG and PNG allowed</li>
    <li>Size limit of 1 MB</li>
    <li>Visible on a dark and light background</li>
    <li>Uses a transparent background</li>
    <li>Aspect ratio of 16:9 or 3:2</li>
    <li>Images over 250px width or 70px height will be scaled to fit</li>
  </ul>
);
